import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { StackLayout, ParagraphText, Icon } from '@leagueplatform/genesis-core';

type IconAndTextNodeProperties = {
  text: string;
  icon?: string;
  iconSize?: string;
  textSize?: 'sm' | 'base' | 'xs';
  spacing?: string;
};

export const NODE_TYPE_ICON_AND_TEXT = 'iconAndText';

export type IconAndTextNode = MasonryEngineNode<
  typeof NODE_TYPE_ICON_AND_TEXT,
  IconAndTextNodeProperties
>;

export type IconAndTextRendererProps =
  MasonryEngineNodeRendererProps<IconAndTextNode>;

export const IconAndTextRenderer = ({
  text,
  icon,
  iconSize = '$oneAndHalf',
  textSize = 'sm',
  spacing = '$half',
}: IconAndTextRendererProps) => (
  <StackLayout
    orientation="horizontal"
    spacing={spacing}
    horizontalAlignment="start"
    verticalAlignment="top"
  >
    <Icon icon={icon} size={iconSize} tint="$onSurfaceIconPrimary" />
    <ParagraphText size={textSize}>{text}</ParagraphText>
  </StackLayout>
);
